import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useTourBuilder } from '../context/TourBuilderContext';

const GOLD = '#B8975A';
const NAVY = '#080e1a';

const ChatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const FloatingActionsStyles = () => (
  <style>{`
    .float-cluster {
      position: fixed;
      right: 24px;
      bottom: 24px;
      z-index: 9998;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 12px;
      transition: opacity 0.3s, transform 0.3s;
    }
    .float-cluster.hidden {
      opacity: 0;
      pointer-events: none;
      transform: translateY(12px);
    }
    @media (max-width: 640px) {
      .float-cluster { bottom: 72px; right: 16px; }
    }

    /* Collapsed = just the icon (a square). Hover / keyboard-focus reveals the label. */
    .fab {
      display: inline-flex;
      align-items: center;
      height: 50px;
      max-width: 50px;
      overflow: hidden;
      border: 1px solid rgba(184,151,90,0.3);
      box-shadow: 0 14px 42px rgba(0,0,0,0.22);
      cursor: pointer;
      text-decoration: none;
      font-family: 'Jost', sans-serif;
      transition: max-width 0.45s cubic-bezier(0.22,1,0.36,1),
                  border-color 0.3s, box-shadow 0.3s;
    }
    .fab:hover,
    .fab:focus-visible {
      max-width: 280px;
      border-color: ${GOLD};
      box-shadow: 0 20px 56px rgba(0,0,0,0.32);
      outline: none;
    }
    .fab-icon {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .fab-label {
      white-space: nowrap;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.16em;
      padding: 0 22px 0 4px;
      opacity: 0;
      transform: translateX(8px);
      transition: opacity 0.25s 0.05s, transform 0.35s cubic-bezier(0.22,1,0.36,1);
    }
    .fab:hover .fab-label,
    .fab:focus-visible .fab-label {
      opacity: 1;
      transform: none;
    }

    .fab-builder            { background: ${NAVY}; }
    .fab-builder .fab-icon  { background: ${GOLD}; }
    .fab-builder .fab-label { color: #fff; }

    .fab-chat            { background: #fff; }
    .fab-chat .fab-icon  { background: rgba(184,151,90,0.10); }
    .fab-chat .fab-label { color: ${NAVY}; }
  `}</style>
);

const FloatingActions = () => {
  const { trigger } = useTourBuilder();
  const { pathname } = useLocation();

  // Hide entirely on the tour builder page — the user is already in the flow
  const isHidden = pathname === '/tour-builder';

  return (
    <>
      <FloatingActionsStyles />
      <div className={`float-cluster${isHidden ? ' hidden' : ''}`}>

        {/* Chat with us */}
        <Link to="/contact" className="fab fab-chat" aria-label="Chat with us" title="Chat with us">
          <span className="fab-icon"><ChatIcon /></span>
          <span className="fab-label">Chat with us</span>
        </Link>

        {/* Tour Builder */}
        <button onClick={trigger} className="fab fab-builder" aria-label="Tour Builder" title="Tour Builder">
          <span className="fab-icon"><Sparkles size={18} color="#fff" /></span>
          <span className="fab-label">Tour Builder</span>
        </button>

      </div>
    </>
  );
};

export default FloatingActions;